
import React from 'react';
import DoctorNotifications from './notifications/DoctorNotifications';

const NotificationCenter = () => {
  return <DoctorNotifications />;
};

export default NotificationCenter;
